'use client'

import { useRef, useState } from 'react'

import { type Logos as LogosType } from '../../../../../apps/benmax/src/types/sanity.types'

import cn from 'clsx'
import s from './Logos.module.sass'

import { ImageBox, NavLink, Copy } from 'shared-components'

import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y } from 'swiper/modules'
import 'swiper/css'

import BlockArrow from '../../../images/blockArrow'

type ExtendedLogosType = LogosType & {
    site: string
}

function Logos({ title, logos, testimonials }: ExtendedLogosType) {
    const sliderRef = useRef<any>(null)
    const [activeIndex, setActiveIndex] = useState(0)

    const handleChangeSlide = (direction: string) => {
        if (direction === 'prev') {
            sliderRef.current.swiper.slidePrev()
        }
        if (direction === 'next') {
            sliderRef.current.swiper.slideNext()
        }
    }
    return (
        <section className={s.Logos}>
            <div className={cn(s.Cont, 'container')}>
                {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                <ul className={s.LogoGrid}>
                    {logos?.map((logo, index) => {
                        const { image, url } = logo
                        const inner = (
                            <>
                                <ImageBox image={image} width={360} height={360} />
                            </>
                        )

                        return (
                            <li className={s.Logo} key={index}>
                                {url ? <NavLink href={url}>{inner}</NavLink> : inner}
                            </li>
                        )
                    })}
                    {testimonials && (
                        <li className={s.Testimonials}>
                            <Swiper
                                modules={[A11y]}
                                spaceBetween={0}
                                slidesPerView={1}
                                ref={sliderRef}
                                loop
                                onSlideChange={(swiper) => {
                                    setActiveIndex(swiper.realIndex)
                                }}
                            >
                                {testimonials.map((testimonial, index) => {
                                    const { copy, name, company } = testimonial

                                    return (
                                        <SwiperSlide key={index}>
                                            <div className={s.Testimonial}>
                                                <Copy copy={copy} size="large bold" />
                                            </div>
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        </li>
                    )}
                </ul>
                {testimonials && (
                    <div className={s.Controls}>
                        <button onClick={() => handleChangeSlide('prev')}>{BlockArrow}</button>
                        <div className={s.Info} key={activeIndex}>
                            {testimonials[activeIndex]?.company && (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: testimonials[activeIndex].company,
                                    }}
                                />
                            )}
                            {testimonials[activeIndex]?.name && (
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: testimonials[activeIndex].name,
                                    }}
                                />
                            )}
                        </div>
                        <button onClick={() => handleChangeSlide('next')}>{BlockArrow}</button>
                    </div>
                )}
            </div>
        </section>
    )
}

export default Logos
